<template>
  <div class="text-center pb-16">
    <!-- แสดงผล : กรณีที่ 'ไม่' สามารถลงทะเบียนล่วงหน้าได้ เพราะไม่ได้ Login หรือ session หลุด -->
    <div v-if="page_state === all_page_states.DISPLAY_INFO_NOT_LOGGED_IN">
      <h1 class="mt-4">
        {{ $t("pre_regis_pageinfo.not_yet_logged_in_or_not_at_given_time") }}
      </h1>
      <h2 class="mt-5 pt-5 pb-5">
        {{ $t("pre_regis_pageinfo.back_to_log_in_page") }}
      </h2>
      <v-btn depressed class="deep-orange white--text mt-5">{{
        $t("pre_regis_pageinfo.go_to_log_in_page")
      }}</v-btn>
    </div>

    <!-- แสดงผล : กรณีที่ 'ไม่' สามารถลงทะเบียนล่วงหน้าได้ เพราะไม่ได้อยู่ในช่วงลงทะเบียนล่วงหน้า -->
    <div
      v-if="page_state === all_page_states.DISPLAY_INFO_NOT_IN_PRE_REGIS_PERIOD"
    >
      <h1 class="mt-4">
        {{ $t("pre_regis_pageinfo.not_during_pre_registration_period") }}
      </h1>
      <!-- <h2 class="mt-5 pt-5 pb-5">
        {{ $t("pre_regis_pageinfo.pre_registration_period") }}
        {{ $t("pre_regis_pageinfo.year") }} {{ year_semester }}
        {{ $t("pre_regis_pageinfo.is") }}
      </h2>
      <h2 class="pt-5 pb-5">{{ startPreRegisDate_endPreRegisDate }}</h2> -->
    </div>

    <!-- แสดงผล : กรณีที่ 'ไม่' สามารถลงทะเบียนล่วงหน้าได้ เพราะไม่ได้อยู่ในสถานะ 'เรียน' -->
    <div v-if="page_state === all_page_states.DISPLAY_INFO_NOT_STUDY_STATUS">
      <h1 class="mt-4">
        {{
          $t("pre_regis_pageinfo.not_in_study_status_so_cant_pre_registrtion")
        }}
      </h1>
    </div>

    <!-- แสดงผล : กรณีที่ 'ไม่' สามารถลงทะเบียนล่วงหน้าได้ เพราะเป็น นศ.ปี 1 เทอม 1 -->
    <div
      v-if="
        page_state ===
          all_page_states.DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER
      "
    >
      <h1 class="mt-4">
        {{
          $t("pre_regis_pageinfo.student_1st_year_semester_1_cant_pre_register")
        }}
      </h1>
      <h2 class="mt-5 pt-5 pb-5">
        {{
          $t(
            "pre_regis_pageinfo.because_registered_according_to_plan_for_student_1st_year_semester_1"
          )
        }}
      </h2>
    </div>

    <!-- แสดงผล : กรณีที่ 'ไม่' สามารถลงทะเบียนล่วงหน้าได้ เพราะมีข้อมูลในตาราง r_student_no_right -->
    <div v-if="page_state === all_page_states.DISPLAY_INFO_NO_RIGHT">
      <h1 class="mt-4">
        {{ $t("pre_regis_pageinfo.students_cant_pre_register_because") }}
      </h1>
      <div v-for="(item, i) in data_student_no_right" :key="i" class="mt-5">
        <h3>{{ item.cause }}</h3>
      </div>

      <!-- <h3 class="pt-5 pb-5 red--text ">
        {{
          $t(
            "pre_regis_pageinfo.have_any_inquiries_please_dont_hesitate_to_contact"
          )
        }}
      </h3> -->
    </div>

    <!-- แสดงผล : กรณีที่หมดช่วงเวลาลงทะเบียนล่วงหน้าแล้วและนักศึกษายังไม่ได้ลงทะเบียน -->
    <div
      v-if="
        page_state ===
          all_page_states.DISPLAY_INFO_NEVER_REGIS_AND_AFTER_PRE_REGIS_DATE
      "
    >
      <h1 class="mt-4">
        {{
          $t(
            "pre_regis_pageinfo.students_dont_pre_register_during_the_specified_period"
          )
        }}
      </h1>
      <v-btn depressed color="orange darken-2"  elevation="3" class="mt-3 mb-3">
        <a class="btn_calendar" href="https://www.reg.kmitl.ac.th/educalendar/" target="_blank">{{ $t("regis_pageinfo.see_calendar") }}</a>
      </v-btn>
    </div>

    <!-- แสดงผล : กรณีที่สามารถลงทะเบียนล่วงหน้าได้ -->
    <div v-if="page_state === all_page_states.DISPLAY_INFO_DEFAULT">
      <v-btn depressed color="primary" class="mt-3 mb-3">
        {{ $t("pre_regis_pageinfo.registration_check_result") }}
      </v-btn>
      <br />
      <v-divider></v-divider>
      <v-img
        v-if="language === 'en'"
        src="https://picsum.photos/id/11/500/300"
      ></v-img>
      <v-img v-else src="https://picsum.photos/1920/1080?random"></v-img>
    </div>
  </div>
</template>
<script>
import * as dayjs from "dayjs";
var buddhistEra = require("dayjs/plugin/buddhistEra");
dayjs.extend(buddhistEra);

export default {
  name: "PageInfoPreRegis",
  props: {
    data_student_no_right: {
      type: Array,
    },
    all_page_states: {
      type: Object,
    },
    page_state: {
      type: String,
      default: "",
    },
  },
  computed: {
    // year_semester() {
    //   return (
    //     this.$store.state.preRegistration.semester +
    //     "/" +
    //     this.$store.state.preRegistration.year
    //   );
    // },
    // startPreRegisDate_endPreRegisDate() {
    //   if (this.language == "en") {
    //     const start_date = dayjs(
    //       this.$store.state.preRegistration.startPreRegisDate
    //     )
    //       .locale("en")
    //       .format("ddd MMM D, YYYY h:mm A");
    //     const end_date = dayjs(
    //       this.$store.state.preRegistration.endPreRegisDate
    //     )
    //       .locale("en")
    //       .format("ddd MMM D, YYYY h:mm A");
    //     return start_date + " - " + end_date;
    //   } else {
    //     const start_date = dayjs(
    //       this.$store.state.preRegistration.startPreRegisDate
    //     )
    //       .locale("th")
    //       .format("วันdddd ที่ D MMM BBBB เวลา HH:mm น.");
    //     const end_date = dayjs(
    //       this.$store.state.preRegistration.endPreRegisDate
    //     )
    //       .locale("th")
    //       .format("วันdddd ที่ D MMM BBBB เวลา HH:mm น.");
    //     return start_date + " - " + end_date;
    //   }
    // },
    language() {
      return this.$root.$i18n.locale;
    },
  },
};
</script>
<style scoped>
.btn_calendar{
  text-decoration: none;
  color: white;
}
</style>
